
import React from 'react';
import { useSnackbarNotify } from '../hooks/useSnackbarNotify';
import { ApiContext } from './ApiContext';
import { IApiErrorStrings } from '../localization/apiErrors/IApiErrorString';

interface IProps {
    children: any;
    strings: IApiErrorStrings;
    onRedirect: VoidFunction;
}

export const ApiProvider = ({ children, strings, onRedirect }: IProps) => {
    const notify = useSnackbarNotify();

    return (
        <ApiContext.Provider
            value={{
                strings: strings,
                notify: notify,
                redirect: onRedirect,
            }}>
            {children}
        </ApiContext.Provider>
    );
}